import type { Cart } from "@/graphql/storefront/generated";

export type CartAttribute = { key: string; value: string };

type AttributeLike = { key: string; value?: string | null };

/**
 * A leading underscore marks the site's own stamps (the referral marker, the
 * landing-page package), which Shopify keeps out of the checkout. A form that
 * rewrites the attribute set never means to drop them.
 */
export const isPrivateAttributeKey = (key: string) => key.startsWith("_");

export const privateAttributes = (
  attributes: readonly AttributeLike[] | null | undefined,
): CartAttribute[] =>
  (attributes ?? []).flatMap((attribute) =>
    isPrivateAttributeKey(attribute.key) && attribute.value != null
      ? [{ key: attribute.key, value: attribute.value }]
      : [],
  );

/**
 * The cart's attributes with `extra` set on top: cartAttributesUpdate replaces
 * the whole set, so an update has to carry the others along.
 */
export const mergeCartAttributes = (
  cart: Cart | undefined,
  extra: Record<string, string>,
): Record<string, string> => {
  const merged: Record<string, string> = {};
  for (const attribute of cart?.attributes ?? []) {
    if (attribute.value != null) {
      merged[attribute.key] = attribute.value;
    }
  }
  return { ...merged, ...extra };
};
